document.addEventListener('DOMContentLoaded', () => {
  const initTccSlider = () => {
    const sections = document.querySelectorAll('[data-section-type="two-col-content"]');
    
    sections.forEach((section) => {
      const swiperEl = section.querySelector('.two-col-content__swiper');
      if (!swiperEl || swiperEl.classList.contains('swiper-initialized')) return;

      const toBool = (value) => {
        if (value === true || value === 'true' || value === '1') return true;
        if (value === false || value === 'false' || value === '0' || value == null) return false;
        const str = String(value).trim().toLowerCase();
        return str === 'true' || str === '1';
      };

      const toInt = (value, defaultValue) => {
        if (value == null || value === '') return defaultValue;
        const n = parseInt(value, 10);
        return Number.isFinite(n) ? n : defaultValue;
      };

      const speed = toInt(section.dataset.speed, 600);
      const autoplayEnabled = toBool(section.dataset.autoplay);
      const delay = toInt(section.dataset.delay, 4000);
      const effect = section.dataset.effect || 'slide';

      const paginationEl = section.querySelector('.two-col-content__pagination');

      const options = {
        loop: true,
        speed,
        effect,
        slidesPerView: 1,
        spaceBetween: 0,
        grabCursor: true,
        pagination: paginationEl ? {
          el: paginationEl,
          clickable: true,
        } : undefined,
      };

      if (autoplayEnabled) {
        options.autoplay = { delay, disableOnInteraction: false };
      }

      try {
        new Swiper(swiperEl, options);
      } catch (e) {
        console.error('Two-col-content slider init error:', e);
      }
    });
  };

  initTccSlider();

  // Re-init on Shopify design mode events
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('[data-section-type="two-col-content"]')) {
      initTccSlider();
    }
  });
});